import { Button, Typography } from "@mui/material";
import Flex, { FlexProps } from "./Flex";
import StyledDialog from "./StyledDialog";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import { useEffect, useState } from "react";

interface SuccessDialogProps {
  label: string;
  opened: boolean;
  onClose: () => void;
  w?: string | number;
  flexProps?: FlexProps;
}

const SuccessModal = ({
  label,
  opened,
  onClose,
  flexProps,
  w = "32em",
}: SuccessDialogProps) => {
  return (
    <StyledDialog open={opened} onClose={onClose} disableCloseIcon>
      <Flex
        width={w}
        gap={flexProps?.gap || "16px"}
        {...flexProps}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <VerifiedRoundedIcon color="success" sx={{ fontSize: "4rem" }} />
        <Typography px={2} fontSize={22} textAlign={"center"} fontWeight={400}>
          {label}
        </Typography>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ marginTop: "20px", paddingX: "2rem" }}
        >
          Okay
        </Button>
      </Flex>
    </StyledDialog>
  );
};

type SuccessAction = { open: () => void; close: () => void };
/**
 * @returns  successHost
 */
export type SuccessHost = [boolean, SuccessAction];
/**
 * this hook develop to handle close for success modal
 * @see after open modal close modal just after 2 sec
 *
 *
 * @author rajkumar rathod
 */
export const useSuccess = (onClose?: () => void): SuccessHost => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  /**
   * check - close only while while success modal is open
   * immediately close after 2 sec
   */
  useEffect(() => {
    if (isOpen)
      setTimeout(() => {
        setIsOpen(false);
        onClose?.();
      }, 2000);
  }, [isOpen]);

  /** actions to perform manually close open */
  const open = () => setIsOpen(true);
  const close = () => {
    setIsOpen(false);
    onClose?.();
  };

  return [isOpen, { open, close }] as SuccessHost;
};

export default SuccessModal;
